import { ValidatorRuleType } from "@tSurya/Common/Utilities/validate";

export const intialErrorFormStateLegacy = {
    shipToName: "",
    street1: "",
    street2: "",
    street3: "",
    zipCode: "",
    city: "",
    country: "",
    phone: "",
    sidemark: "",
    poNumber: "",
    check: "",
    quantity: "",
    email: "",
};

export const intialErrorFormState = {
    shipToName: "",
    street1: "",
    street2: "",
    street3: "",
    zipCode: "",
    city: "",
    country: "",
    phone: "",
    sidemark: "",
    poNumber: "",
    check: "",
    quantity: "",
    email: "",
};

export interface ValidatorConfigType {
    [key: string]: ValidatorRuleType;
}

export interface FormErrorsStateType {
    [key: string]: string | undefined;
}

export const NewCustomerValidatorConfig: ValidatorConfigType = {
    shipToName: {
        required: true,
        minLength: 1,
        label: "Ship To Name",
    },
    street1: {
        required: true,
        minLength: 1,
        label: "Ship To Street1",
    },
    street2: {
        required: true,
        minLength: 1,
        label: "Ship To Street2",
    },
    zipCode: {
        required: true,
        regex: /^[0-9]+$/,
        label: "Zip Code",
    },
    city: {
        required: true,
        minLength: 1,
        label: "City",
    },
    country: {
        required: true,
        minLength: 1,
        label: "Country",
    },
    phone: {
        required: true,
        label: "Phone Number",
        minLength:10,
        minLengthMsg:"Phone Number should contain at least 10 digits.",
    },
    check: {
        required: true,
        regex: /^[0-9]+$/,
        label: "Check",
        value: true,
        requiredField: "Check Number cannot be zero",
    },
    poNumber: {
        required: true,
        minLength: 1,
        label: "PO Number",
    },
    sidemark: {
        minLength: 1,
        label: "Side Mark",
    },
    quantity: {
        required: true,
        regex: /^[0-9]+$/,
        label: "QTY",
        value: true,
    },
    email: {
        required: true,
        minLength: 1,
        label: "Email",
    },
};
